import React, { Component } from "react";
import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Fab,
  Button,
  TextField,
  InputLabel,
  FormControl,
  Select,
  Divider,
} from "@material-ui/core";
import { GoSearch } from "react-icons/go";
import DeleteIcon from "@material-ui/icons/Delete";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import QueriesPopover from '../QueriesPopover'
import SimpleDateTime  from 'react-simple-timestamp-to-date'
import Modal from "react-awesome-modal";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import "./QueryTable.css";
import { GoogleComponent } from "react-google-location";
import { Map, Circle, GoogleApiWrapper } from "google-maps-react";
import firebase from "firebase/app";
import firestore from "firebase/firestore";
// import { firebaseConfig } from './Components/FirebaseConfig';
import { firebaseConfig } from "../FirebaseConfig";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import Geocode from "react-geocode";
import {
  BrowserRouter as Router,
  Link,
  Redirect,
  useHistory,
} from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
toast.configure();

export class QueryRejectedTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      button: true,
      queries: [],
      cnic: null,
      first_name: null,
      last_name: null,
      query: null,
      query_status: null,
      description: null,
      query_time:null,
      visible: false,
      query_web_status: null,
      f_name: null,
      l_name: null,
      m_cnic: null,
      desc: null,
      search:''
    };
    // this.handleClick = this.handleClick.bind(this);
    this.onInputChange = this.onInputChange.bind(this);

  }

  // handleClick() {
  //     this.setState({
  //         button: !this.state.button
  //     })
  // }

  componentDidMount() {
    this.getQueryData();
  }

  getQueryData = async () => {
    //get violations data from firebase
    console.log("func chal raha hai k nhe ")
    

    if (this.state.search == null || this.state.search == "" || this.state.search == '') {
      let tempdata = [];

      const db = firebase.firestore();
      const snapshot = await db
      .collection("queries")
      .orderBy("publishTime", "asc")
      .get();

      snapshot.forEach((doc) => {
        let tempobj = {
          uid: doc.id,
          cnic: doc.data().cnic,
          first_name: doc.data().first_name,
          last_name: doc.data().last_name,
          query: doc.data().query,
          description: doc.data().description,
          query_web_status: doc.data().query_web_status,
          query_time:doc.data().publishTime,
        };
        // tempdata.push(tempobj);
        if(tempobj.query_web_status == "Denied")
        {
          tempdata.push(tempobj);
        }
        else
        {
          console.log("NOt working")
        }

      });
      this.setState({ queries: []});
      this.setState({ queries: tempdata });
      
    } else {

      const db = firebase.firestore();
      let tempdata = [];

      const snapshot = await db
      .collection("queries")
      .orderBy("cnic", "desc")
      .where('cnic', '>=', this.state.search)
      .where('cnic', '<=', this.state.search+"\uf8ff")
      .get();

      snapshot.forEach((doc) => {
        let tempobj = {
          uid: doc.id,
          cnic: doc.data().cnic,
          first_name: doc.data().first_name,
          last_name: doc.data().last_name,
          query: doc.data().query,
          description: doc.data().description,
          query_web_status: doc.data().query_web_status,
          query_time:doc.data().publishTime,
        };
        // tempdata.push(tempobj);
        if(tempobj.query_web_status == "Denied")
        {
          tempdata.push(tempobj);
        }
        else
        {
          console.log("NOt working")
        }

      });

      this.setState({ queries: []});
      this.setState({ queries: tempdata });
      
    }
      
      // .where('cnic', '>=', this.state.search)
      // .where('cnic', '<=', this.state.search+"\uf8ff")
      // .startAt([this.state.search])
      // .endAt([this.state.search+"\uf8ff"])
     

    // snapshot.forEach((doc) => {
    //   let tempobj = {
    //     uid: doc.id,
    //     first_name: doc.data().first_name,
    //     last_name: doc.data().last_name,
    //     cnic: doc.data().cnic,
    //     fine: doc.data().fine,
    //     violation_status: doc.data().violation_status,
    //     zone_id: doc.data().zone_id,
    //     exit_time: doc.data().exit_time,
    //     exit_zone: doc.data().exit_zone,
    //     email: doc.data().email,
    //   };
    //   tempdata.push(tempobj);
    // });
    // this.setState({ violations: tempdata });
  };

  onInputChange = async(event) => {

    // let string = event.target.value.toLower
    if (event.target.value.length < 1) {
      event.target.value = '';
      // this.getViolationData()     
      console.log("if ki value =", event.target.value)
      this.setState({ [event.target.name]: event.target.value.toLowerCase()});

      let tempdata = [];

      const db = firebase.firestore();
      const snapshot = await db
      .collection("queries")
      .orderBy("publishTime", "asc")
      .get();

      snapshot.forEach((doc) => {
        let tempobj = {
          uid: doc.id,
          cnic: doc.data().cnic,
          first_name: doc.data().first_name,
          last_name: doc.data().last_name,
          query: doc.data().query,
          description: doc.data().description,
          query_web_status: doc.data().query_web_status,
          query_time:doc.data().publishTime,
        };
        // tempdata.push(tempobj);
        if(tempobj.query_web_status == "Denied")
      {
        tempdata.push(tempobj);
      }
      else
      {
        console.log("NOt working")
      }
        
      });
      this.setState({ queries: []});
      this.setState({ queries: tempdata });

    } else {
      console.log("else ki value =", event.target.value)
      this.setState({ [event.target.name]: event.target.value.toLowerCase()});
    }
    this.getQueryData()      
}

  // getQueryData = async () => {
  //   //get violations data from firebase
  //   let tempdata = [];
  //   const db = firebase.firestore();
  //   const snapshot = await db.collection("queries").orderBy('publishTime', "desc").get();

  //   snapshot.forEach((doc) => {
  //     let tempobj = {
  //       uid: doc.id,
  //       cnic: doc.data().cnic,
  //       first_name: doc.data().first_name,
  //       last_name: doc.data().last_name,
  //       query: doc.data().query,
  //       description: doc.data().description,
  //       query_web_status: doc.data().query_web_status,
  //       query_time:doc.data().publishTime,
  //     };
  //     if(tempobj.query_web_status == "Denied")
  //     {
  //       tempdata.push(tempobj);
  //     }
  //     else
  //     {
  //       console.log("NOt working")
  //     }
  //     // tempdata.push(tempobj);
  //   });
  //   this.setState({ queries: tempdata });
  // };

  addQueryData = async (add_id, add_status, web_status) => {
    this.setState({ status: "yes" });
    const db = firebase.firestore();
    const docRef = db.collection("queries").doc(add_id);
    await docRef.update({
      query_status: add_status,
      query_web_status: web_status,
    });
    toast("Query Updated Successfully", {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 5000,
      hideProgressBar: true,
    });
  };

  deleteQueryData = async (delete_id) => {
    const db = firebase.firestore();
    const res = await db.collection("queries").doc(delete_id).delete();
    toast("Zone Deleted Successfull", {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 5000,
      hideProgressBar: true,
    });
    // await this.reloadPage();
    this.getCordinates();
  };

  dateConvertor(value){
    if(value == null)
    {
      // console.log("mar gye")
      return(
        <a>--</a>
      )
    }
    else
    {
        return(
              <SimpleDateTime dateSeparator="/" format="DMY" timeSeparator=":" meridians="1" >
          {value/1000}
        </SimpleDateTime>
        )
    
    }
 }

  render() {
    return (
      <Paper className={"queryPaperCss"}>
         <div
          style={{
            height: "6.2vh",
            width: "100%",
            backgroundColor: "white",
            display:'flex',
            justifyContent:'flex-end',
            alignItems:'center',
            // marginBottom:'5%'
          }}
        >
          <div className={'querySearchInputDiv'}>
          <input
            className={'querySearchInput'}
            type={"text"}
            placeholder={"Search data..."}
            name={"search"}
            value={this.state.search}
            onChange={this.onInputChange}
          />
          <GoSearch style={{ height: 20, width: 20, color: '#21618C' }} />                            
          </div>
          
        </div>
        <TableContainer className={"queryTableContainerCss"}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell align="center" className={"queryTableCell"}>
                  NAME
                </TableCell>
                <TableCell align="center" className={"queryTableCell"}>
                  CNIC
                </TableCell>
                <TableCell align="center" className={"queryTableCell"}>
                  QUERY
                </TableCell>
                <TableCell align="center" className={"queryTableCell"}>
                  STATUS
                </TableCell>
                <TableCell align="center" className={"queryTableCell"}>
                  DESCRIPTION
                </TableCell>
                <TableCell align="center" className={"queryTableCell"}>
                  DATE/TIME
                </TableCell>
                <TableCell align="center" className={"queryTableCell"}>
                  ACTIONS
                </TableCell>

              </TableRow>
            </TableHead>

            <TableBody>
              {this.state.queries.map((value) => (
                <TableRow>

                  <TableCell align="center">
                    {value.first_name} {value.last_name}
                  </TableCell>
                  <TableCell align="center">{value.cnic}</TableCell>
                  <TableCell align="center">{value.query}</TableCell>
                  <TableCell align="center">{value.query_web_status}</TableCell>
                  <TableCell align="center">
                    <QueriesPopover message={value.description}/>
                  </TableCell>
                  <TableCell align="center">
                    {value.query_time}
                  </TableCell>
                  <TableCell align="center">
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <DeleteIcon
                      className={'queryEditDeleteIcon'}
                      onClick={() => {
                          this.deleteQueryData(value.uid);
                        }}
                      />
                    </div>
                  </TableCell>
                  
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    );
  }
}
// export default ZonesTable;
export default GoogleApiWrapper({
  apiKey: "AIzaSyA_d3pS7JqjFnGWc9hHkvT2MUQvAKo5Bio",
})(QueryRejectedTable);
